// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SyncResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/anticipations/sync/{id}
 *
 * Returns the provider sync outcome (`sync_result`) plus the freshly-reloaded
 * anticipation DB record (`anticipation`, enriched with `status_info`). Both
 * fields point at sibling Row classes so the Spatie TS pipeline projects a
 * typed interface for each, and `FF_STRICT_ROW_CONTRACTS=1` catches drift if
 * either source shape gains a key not declared on the Row.
 *
 * @see anticipations.php::sync()
 */
import type { SubaccountsAnticipations_SyncAnticipationRow } from './SubaccountsAnticipations_SyncAnticipationRow'
import type { SubaccountsAnticipations_SyncResultRow } from './SubaccountsAnticipations_SyncResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_SyncResponseDados {
sync_result: SubaccountsAnticipations_SyncResultRow
anticipation: SubaccountsAnticipations_SyncAnticipationRow
}

export type SubaccountsAnticipations_SyncResponse = ApiResponse<SubaccountsAnticipations_SyncResponseDados>;

registerResponseContract('SubaccountsAnticipations_SyncResponse', {
  sync_result: {
    type: 'object',
    required: true,
    fields: {
      status:     { type: 'string',  required: true },
      message:    { type: 'string',  required: false },
      old_status: { type: 'string',  required: false },
      new_status: { type: 'string',  required: false },
    },
  },
  anticipation: {
    type: 'object',
    required: true,
    fields: {
      id:                       { type: 'number',  required: true },
      subaccount_id:            { type: 'number',  required: true },
      payment_link_id:          { type: 'number',  required: false },
      provider_code:            { type: 'string',  required: true },
      provider_anticipation_id: { type: 'string',  required: true },
      provider_payment_id:      { type: 'string',  required: false },
      provider_installment_id:  { type: 'string',  required: false },
      status:                   { type: 'string',  required: true },
      request_date:             { type: 'string',  required: true },
      anticipation_date:        { type: 'string',  required: false },
      due_date:                 { type: 'string',  required: false },
      anticipation_days:        { type: 'number',  required: false },
      total_value:              { type: 'number',  required: true },
      anticipation_value:       { type: 'number',  required: true },
      fee:                      { type: 'number',  required: true },
      net_value:                { type: 'number',  required: true },
      denial_observation:       { type: 'string',  required: false },
      is_automatic:             { type: 'number',  required: true },
      created_at:               { type: 'string',  required: true },
      updated_at:               { type: 'string',  required: true },
      last_synced_at:           { type: 'string',  required: false },
      status_info: {
        type: 'object',
        required: true,
        fields: {
          name:        { type: 'string',  required: true },
          description: { type: 'string',  required: true },
          severity:    { type: 'string',  required: true },
          is_final:    { type: 'boolean', required: true },
        },
      },
    },
  },
})
